<template>
    <v-dialog v-model="mostrar" persistent max-width="70vw" >
		<v-card max-height="600px">
			<v-toolbar flat :color="this.$store.state.title == 'Calendario' ? this.$store.state.corEvento : cor"></v-toolbar>
			<v-divider></v-divider>
            <v-card-text>
                <v-row>
                    <v-col cols="12">
                        <h2 class="text-center">Você está excluindo a pessoa "{{pessoa.nome}}"</h2>
                        <h3 class="text-center">Confirma a exclusão?</h3>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text color="primary" @click.stop="confirmar()">Confirmar</v-btn>
				<v-btn text color="primary" @click.stop="fechar()">Cancelar</v-btn>
			</v-card-actions>
		</v-card>
    </v-dialog>    
</template>

<script>
import metodos from '@/mixins/metodos'

//import { mapState } from 'vuex'
import { baseApiUrl, showError, showSuccess } from "@/config/global"
import axios from 'axios'


export default {
    name: 'ExcluirPessoa',
    mixins: [metodos],
    props:['mostrar', 'pessoa'],
    components:{
        
    },
    data(){
        return{
            cor: 'primary',
        }
    },

    methods:{
        confirmar(){
            const url = `${baseApiUrl}/Atendimentos/Pessoas/delete.php`

                axios.post(url, {id: this.pessoa.id})
                    .then(res => {
                        if(res.data.codigo == '01'){
                            showSuccess(res.data.mensagem)
                            this.$emit('pessoaExcluida', this.pessoa)
                        }else{
                            showError(res.data.mensagem)
                        }
					})
					
            },

            fechar(){
                this.$emit('fecharExcluir')
            }
    },
}
</script>

<style scoped>

</style>